import appConfigApi from './api/appConfigApi';
import covidApi from './api/covidApi';

const api = {
  appConfig: appConfigApi,
  covid: covidApi,
};

export default api;
